import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/layout/app-shell';
import { InvestorShell } from './components/layout/investor-shell';
import { InvestorFilterProvider } from './lib/investor-filter';
import { RouteGuard } from './components/route-guard';
import { useAuth } from './lib/auth-context';
import Overview from './pages/Overview';
import Actions from './pages/Actions';
import Settings from './pages/Settings';
import Strategies from './pages/Strategies';
import Wallets from './pages/Wallets';
import Screener from './pages/Screener';
import Login from './pages/Login';
import InvestorDashboard from './pages/investor/Dashboard';

/** Operator dashboard. Investors are bounced to /invest — they never see
 *  the ops surface (the API also 403s them; this is the UI half). */
function OperatorGate() {
  const { user } = useAuth();
  if (user?.role === 'investor') return <Navigate to="/invest" replace />;
  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/wallets" element={<Wallets />} />
        <Route path="/screener" element={<Screener />} />
        <Route path="/actions" element={<Actions />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Overview />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      {/* aHedge investor dashboard — one page, reachable by any authenticated
          role (the investor role lives here; operators get a preview). */}
      <Route
        path="/invest"
        element={
          <RouteGuard>
            <InvestorFilterProvider>
              <InvestorShell>
                <InvestorDashboard />
              </InvestorShell>
            </InvestorFilterProvider>
          </RouteGuard>
        }
      />
      {/* Old per-section links collapse to the single page. */}
      <Route path="/invest/*" element={<Navigate to="/invest" replace />} />

      {/* Operator dashboard (or redirect investors to /invest) */}
      <Route
        path="/*"
        element={
          <RouteGuard>
            <OperatorGate />
          </RouteGuard>
        }
      />
    </Routes>
  );
}
